import {
    isValidCPF,
    isValidCNPJ,
    isValidNumericCNPJ,
} from '@inhouse-market/sdk';
import values from '@/env';
import { getFlagSnapshot } from '@/contexts/Flags/snapshot';

export enum DocumentEnum {
    CPF = 'cpf',
    CNPJ = 'cnpj',
}

export const MASKS_DOCUMENT = {
    cpf: '999.999.999-99',
    get cnpj(): string {
        return shouldAllowAlphanumericCnpj()
            ? '**.***.***/****-99'
            : '99.999.999/9999-99';
    },
};

export const messageError = {
    [DocumentEnum.CPF]: 'CPF inválido',
    [DocumentEnum.CNPJ]: 'CNPJ inválido',
};

export const normalizeDoc = (value?: string): string =>
    (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

function shouldAllowAlphanumericCnpj(): boolean {
    const CNPJ_ALPHANUMERIC = getFlagSnapshot('CNPJ_ALPHANUMERIC');

    if (typeof CNPJ_ALPHANUMERIC === 'boolean') {
        return CNPJ_ALPHANUMERIC;
    }

    if (CNPJ_ALPHANUMERIC && typeof CNPJ_ALPHANUMERIC === 'object') {
        const env = values.ENV;

        if (env === 'production') {
            return !!CNPJ_ALPHANUMERIC.production;
        }

        if (env === 'staging') {
            return !!CNPJ_ALPHANUMERIC.staging;
        }

        return !!(CNPJ_ALPHANUMERIC.develop ?? CNPJ_ALPHANUMERIC.development);
    }

    return false;
}

export const validateDocument = (
    value: string,
    docType: DocumentEnum,
): string | null => {
    const clean = normalizeDoc(value);

    if (!clean) return null;

    if (docType === DocumentEnum.CPF) {
        if (clean.length !== 11) return messageError[DocumentEnum.CPF];
        if (!isValidCPF(clean)) return messageError[DocumentEnum.CPF];
        return null;
    }

    if (docType === DocumentEnum.CNPJ) {
        const isAlphanumericEnabled = shouldAllowAlphanumericCnpj();

        if (!isAlphanumericEnabled && !/^\d{14}$/.test(clean)) {
            return messageError[DocumentEnum.CNPJ];
        }

        const isValid = isAlphanumericEnabled
            ? isValidCNPJ(clean)
            : isValidNumericCNPJ(clean);

        if (!isValid) return messageError[DocumentEnum.CNPJ];
        return null;
    }

    return 'Documento inválido';
};
